import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';

import { TSIconModule, TsButtonModule, TsColorBubbleComponent, TsOverlayModule } from 'tsui';
import { GalleryModule } from 'ng-gallery';
import { LightboxModule } from 'ng-gallery/lightbox';
import { WidgetsModule } from '../widgets/widgets.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { EditableModule } from '../editable/editable.module';
import { FormFieldsModule } from '../form-fields/form-fields.module';
import { PanelFormComponent } from './form/form.component';
import { PanelHostComponent } from './panel-host.component';
import { PanelImagesComponent } from './gallery/gallery.component';
import { PanelCommentsComponent } from './comments/comments.component';
import { PanelTableComponent } from './related-table/related-table.component';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { AccountColorBackgroundDirective } from '@shared/directives/account-color-background.directive';
import { RelatedTableCoreComponent } from '@shared/components/panels/components/related-table-core/related-table-core.component';
import { TsTableComponent } from 'tsui/lib/ts-table';
import { PanelsActivityComponent } from './activity/activity.component';

const MATERIAL_ASSETS = [
  MatIconModule,
  MatMenuModule,
  MatInputModule,
  MatTableModule,
  MatButtonModule,
  MatTooltipModule,
  MatFormFieldModule,
  MatProgressBarModule,
];

const STANDALONE_PANELS_COMPONENTS = [RelatedTableCoreComponent];

const PANELS = [
  PanelFormComponent,
  PanelHostComponent,
  PanelImagesComponent,
  PanelCommentsComponent,
  PanelTableComponent,
  PanelsActivityComponent,
];

const TSUI = [TSIconModule, TsColorBubbleComponent, TsTableComponent];
@NgModule({
  declarations: [...PANELS],
  exports: [...PANELS],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormFieldsModule,
    DragDropModule,
    EditableModule,
    DirectivesModule,
    WidgetsModule,
    AccountColorBackgroundDirective,
    PipesModule,
    GalleryModule,
    LightboxModule,
    TsOverlayModule,
    TsButtonModule,
    ...MATERIAL_ASSETS,
    ...TSUI,
    ...STANDALONE_PANELS_COMPONENTS,
  ],
})
export class PanelsModule {}
